// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-button{border:0;padding:10px 12px;font-size:12px;color:#777576;background:#fff}.custom-button:focus{outline:none}.custom-button:hover,.custom-button.custom-button--selected{color:#000;background:#c3c4be}", ""]);
// Exports
module.exports = exports;
